import { render, staticRenderFns } from "./GoodAdd.vue?vue&type=template&id=37789945&scoped=true&"
import script from "./GoodAdd.vue?vue&type=script&lang=ts&"
export * from "./GoodAdd.vue?vue&type=script&lang=ts&"
import style0 from "./GoodAdd.vue?vue&type=style&index=0&id=37789945&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37789945",
  null
  
)

export default component.exports